(function() {
    'use strict';

    angular
        .module('cloudApp')
        .service('PaymentService', PaymentService);

    PaymentService.$inject = ['$http'];

    function PaymentService($http) {

        this.sendPayment = function sendInvite(token){
            return $http.post(SERVER_API_URL+'api/payments', token);
        }

    }
})();
